import React from "react";
import { Form } from "antd";
import { CustomInputNumber } from "../../../customComponent/CustomInputNumber";
import { CustomInput } from "../../../customComponent/CustomInput";

export default function FormItemInput({ name, isNumber = false, disabled, controls = true, ...props }) {
  return (
    <Form.Item name={name} style={{ margin: 0, width: "136px" }} {...props}>
      {isNumber ? (
        <CustomInputNumber min={0} style={{ width: "100%" }} disabled={disabled} controls={controls} />
      ) : (
        <CustomInput disabled={disabled} />
      )}
    </Form.Item>
  );
}
